// Messages for various components

import { TableColumn } from 'react-data-table-component';
import { ColumnsFXPoolDetails, IFXPoolDetails, TabsFXReports } from '../../Pages/FXReports/Interface';
import { ISelectedDateRange, ISelectedDateRangeString } from '../DataGrid/Interface';
import moment from 'moment';
import { formatLimit } from '../config';
import React from 'react';

export enum UserStatus {
  ACTIVE = 2,
  BLOCKED = 3
}
export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  EXPIRED = "EXPIRED",
  BLOCKED = "BLOCKED",
  REDEEMED = "REDEEMED",
  VALID = "VALID",
  UNKNOWN = "UNKNOWN"
}

export interface ReportsStateCommon {
  accessToken: string;
  currentRowsPerPage?: number;
  currentPage: number;
  paginationReset?: boolean;
  totalRows?: number;
  searchText?: string;
  selectedDateRange: ISelectedDateRangeString;
  userId?: string;
  emailId?: string;
  countryId?: string;
}

export interface ReportsPropsCommon {

}

export const Messages = {
  Errors: {
    apiError: "An error occurred while connecting to the server. Please try again shortly.",
    unexpected: "An unexpected error occurred while saving.",
    couponAmount: "Amount must be greater than 0",
    minTransactionAmt: "Minimum transaction amount must be greater than or equal to the coupon amount.",
    // ... more error messages
  },
  Success: {
    promoCodesaved: "Promo code saved successfully!",
    cashBackCodesaved: "Cashback coupon saved successfully!",
    // ... more success messages
  },
  Warnings: {
    noDataFound: "No data found.",
    unsavedChanges: "You have unsaved changes.",
    // ... more warning messages
  },
  Info: {
    loading: "Loading, please wait...",
    // ... more info messages
  }
};

const states = [
  {
    "name": "Alabama",
    "code": "AL"
  },
  {
    "name": "Alaska",
    "code": "AK"
  },
  {
    "name": "Arizona",
    "code": "AZ"
  },
  {
    "name": "Arkansas",
    "code": "AR"
  },
  {
    "name": "California",
    "code": "CA"
  },
  {
    "name": "Colorado",
    "code": "CO"
  },
  {
    "name": "Connecticut",
    "code": "CT"
  },
  {
    "name": "Delaware",
    "code": "DE"
  },
  {
    "name": "Florida",
    "code": "FL"
  },
  {
    "name": "Georgia",
    "code": "GA"
  },
  {
    "name": "Hawaii",
    "code": "HI"
  },
  {
    "name": "Idaho",
    "code": "ID"
  },
  {
    "name": "Illinois",
    "code": "IL"
  },
  {
    "name": "Indiana",
    "code": "IN"
  },
  {
    "name": "Iowa",
    "code": "IA"
  },
  {
    "name": "Kansas",
    "code": "KS"
  },
  {
    "name": "Kentucky",
    "code": "KY"
  },
  {
    "name": "Louisiana",
    "code": "LA"
  },
  {
    "name": "Maine",
    "code": "ME"
  },
  {
    "name": "Maryland",
    "code": "MD"
  },
  {
    "name": "Massachusetts",
    "code": "MA"
  },
  {
    "name": "Michigan",
    "code": "MI"
  },
  {
    "name": "Minnesota",
    "code": "MN"
  },
  {
    "name": "Mississippi",
    "code": "MS"
  },
  {
    "name": "Missouri",
    "code": "MO"
  },
  {
    "name": "Montana",
    "code": "MT"
  },
  {
    "name": "Nebraska",
    "code": "NE"
  },
  {
    "name": "Nevada",
    "code": "NV"
  },
  {
    "name": "New Hampshire",
    "code": "NH"
  },
  {
    "name": "New Jersey",
    "code": "NJ"
  },
  {
    "name": "New Mexico",
    "code": "NM"
  },
  {
    "name": "New York",
    "code": "NY"
  },
  {
    "name": "North Carolina",
    "code": "NC"
  },
  {
    "name": "North Dakota",
    "code": "ND"
  },
  {
    "name": "Ohio",
    "code": "OH"
  },
  {
    "name": "Oklahoma",
    "code": "OK"
  },
  {
    "name": "Oregon",
    "code": "OR"
  },
  {
    "name": "Pennsylvania",
    "code": "PA"
  },
  {
    "name": "Rhode Island",
    "code": "RI"
  },
  {
    "name": "South Carolina",
    "code": "SC"
  },
  {
    "name": "South Dakota",
    "code": "SD"
  },
  {
    "name": "Tennessee",
    "code": "TN"
  },
  {
    "name": "Texas",
    "code": "TX"
  },
  {
    "name": "Utah",
    "code": "UT"
  },
  {
    "name": "Vermont",
    "code": "VT"
  },
  {
    "name": "Virginia",
    "code": "VA"
  },
  {
    "name": "Washington",
    "code": "WA"
  },
  {
    "name": "West Virginia",
    "code": "WV"
  },
  {
    "name": "Wisconsin",
    "code": "WI"
  },
  {
    "name": "Wyoming",
    "code": "WY"
  }
];

export enum Texts {
  isVisible = 'isVisible',
  isDownloadVisible = 'isDownloadVisible',
  formatDateTimeDisplay = 'MM-DD-YYYY hh:mm A',
  formatDate = 'YYYY-MM-DD',
  formatDateTime = `YYYY-MM-DD HH:mm:ss`,
  formatDateTimeNetworks = `YYYY-MM-DDTHH:mm`,
  langEnUs = 'en-US',
  USD = 'USD',
  SymbolDollar = '$',
  timeZoneUTC = 'UTC'
};

export enum Actions {
  View = "view",
  Edit = "edit",
  Delete = "delete",
  Create = "create"
}

export const getFXReportDefaultPermissions = (value = true) => {
  let fxReportsPermissions: any = {
    isVisible: value
  }
  let tabsFXReports = Object.keys(TabsFXReports);
  for (let tab of tabsFXReports) {
    fxReportsPermissions[`${Texts.isVisible}${tab}`] = value;
    fxReportsPermissions[`${Texts.isDownloadVisible}${tab}`] = value;
  }
  return fxReportsPermissions;
}
export const getCurrentMonthRange = (): ISelectedDateRangeString => {
  return {
    startDate: moment().startOf('month').utc().format(Texts.formatDateTime.toString()),
    endDate: moment().endOf('day').utc().format(Texts.formatDateTime.toString())
  }
}
export const getCurrentMonthRangeAsDate = (): ISelectedDateRange => {
  return {
    startDate: moment().startOf('month').utc().toDate(),
    endDate: moment().endOf('day').utc().toDate()
  }
}

export const getLast30DaysRange = (): ISelectedDateRangeString => {
  return {
    startDate: moment().subtract(30, 'days').startOf('day').utc().format(Texts.formatDateTime.toString()),
    endDate: moment().endOf('day').utc().format(Texts.formatDateTime.toString())
  }
}

export const getLast7DaysRange = (): ISelectedDateRangeString => {
  return {
    startDate: moment().subtract(7, 'days').startOf('day').utc().format(Texts.formatDateTime.toString()),
    endDate: moment().endOf('day').utc().format(Texts.formatDateTime.toString())
  }
}

export const getLast30DaysRangeAsDate = (): ISelectedDateRange => {
  return {
    startDate: moment().subtract(30, 'days').startOf('day').utc().toDate(),
    endDate: moment().endOf('day').utc().toDate()
  }
}

const isColumnHidden = (listColumnsToHide: ColumnsFXPoolDetails[], column: ColumnsFXPoolDetails) => {
  return listColumnsToHide.indexOf(column) > -1;
}

const isColumnExcludedFromExport = (listColumnsToHide: ColumnsFXPoolDetails[], listColumnsToExcludeFromExport: ColumnsFXPoolDetails[], column: ColumnsFXPoolDetails) => {
  return Number(listColumnsToHide.indexOf(column) > -1 || listColumnsToExcludeFromExport.indexOf(column) > -1);
}

export const getColumnsFXPoolDetails = (listColumnsToHide: ColumnsFXPoolDetails[], listColumnsToExcludeFromExport: ColumnsFXPoolDetails[] = []): TableColumn<IFXPoolDetails>[] => {
  let columns: TableColumn<IFXPoolDetails>[] = [
    {
      name: 'Pool ID',
      selector: row => row.poolName || '',
      sortable: true,
      id: ColumnsFXPoolDetails.poolId,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.poolId),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.poolId),
      minWidth: "200px",
      wrap: true
    },
    {
      name: 'Trade Date',
      selector: row => moment(row.tradeDate).format(Texts.formatDateTimeDisplay),
      sortable: true,
      id: ColumnsFXPoolDetails.tradeDate,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.tradeDate),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.tradeDate),
      minWidth: "155px"
    },
    {
      name: 'Settlement Date',
      selector: row => moment(row.settlementDate).format(Texts.formatDateTimeDisplay),
      sortable: true,
      id: ColumnsFXPoolDetails.settlementDate,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.settlementDate),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.settlementDate),
      minWidth: "155px"
    },
    {
      name: 'LiquidityPartnerId',
      selector: row => row.liquidityPartnerId || '',
      sortable: false,
      hide: 1,
      omit: true
    },
    {
      name: 'Liquidity Partner',
      selector: row => row.liquidityPartner || '',
      sortable: true,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.liquidityPartner),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.liquidityPartner),
      id: ColumnsFXPoolDetails.liquidityPartner
    },
    {
      name: 'USD Currency Rate',
      selector: row => formatLimit(row.usdCurrencyRate, Texts.langEnUs, Texts.USD, Texts.SymbolDollar),
      sortable: true,
      id: ColumnsFXPoolDetails.usdCurrencyRate,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.usdCurrencyRate),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.usdCurrencyRate),
      minWidth: "120px",
      right: true
    },
    {
      name: 'From Currency Rate',
      selector: row => formatLimit(row.fromCurrencyRate || '', Texts.langEnUs, row.currencySpent, row.fromCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.fromCurrencyRate,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.fromCurrencyRate),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.fromCurrencyRate),
      minWidth: "130px",
      right: true
    },
    {
      name: 'To Currency Rate',
      selector: row => formatLimit(row.toCurrencyRate, Texts.langEnUs, row.currencyObtained, row.toCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.toCurrencyRate,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.toCurrencyRate),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.toCurrencyRate),
      minWidth: "130px",
      right: true
    },
    {
      name: 'Currency Spent',
      selector: row => row.currencySpent,
      sortable: true,
      id: ColumnsFXPoolDetails.currencySpent,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.currencySpent),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.currencySpent),
      center: true,
      minWidth: "120px"
    },
    {
      name: 'Amount Spent',
      selector: row => formatLimit(row.amountSpent, Texts.langEnUs, row.currencySpent, row.fromCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.amountSpent,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.amountSpent),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.amountSpent),
      right: true,
      minWidth: "120px"
    },
    {
      name: 'Currency Obtained',
      selector: row => row.currencyObtained,
      sortable: true,
      id: ColumnsFXPoolDetails.currencyObtained,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.currencyObtained),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.currencyObtained),
      center: true,
      minWidth: "120px"
    },
    {
      name: 'Amount Obtained',
      selector: row => formatLimit(row.amountObtained || '', Texts.langEnUs, row.currencyObtained, row.toCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.amountObtained,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.amountObtained),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.amountObtained),
      right: true,
      minWidth: "120px"
    },
    {
      name: 'Target Country Corridor',
      selector: row => row.targetCountryCorridor,
      sortable: true,
      id: ColumnsFXPoolDetails.targetCountryCorridor,
      minWidth: "130px",
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.targetCountryCorridor),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.targetCountryCorridor),
      center: true
    },
    {
      name: 'Payout Partner',
      selector: row => row.payoutPartner || '',
      sortable: true,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.payoutPartner),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.payoutPartner),
      id: ColumnsFXPoolDetails.payoutPartner
    },
    {
      name: 'Total Allocated Amount',
      selector: row => formatLimit(row.totalAllocatedAmount || '', Texts.langEnUs, row.currencyObtained, row.toCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.totalAllocatedAmount,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.totalAllocatedAmount),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.totalAllocatedAmount),
      minWidth: "140px",
      right: true
    },
    {
      name: 'Total Reversed Amount',
      selector: row => formatLimit(row.totalReversedAmount || '', Texts.langEnUs, row.currencyObtained, row.toCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.totalReversedAmount,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.totalReversedAmount),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.totalReversedAmount),
      minWidth: "130px",
      right: true
    },
    {
      name: 'Effective Remaining Balance',
      selector: row => formatLimit(row.effectiveRemainingBalance || 0, Texts.langEnUs, row.currencyObtained, row.toCurrencySymbol),
      sortable: true,
      id: ColumnsFXPoolDetails.effectiveRemainingBalance,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.effectiveRemainingBalance),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.effectiveRemainingBalance),
      minWidth: "160px",
      right: true
    },
    {
      name: 'Pool Status',
      selector: row => row.poolStatus || '',
      cell: (row) => {
        return <span className={`status-label ${row.poolStatus?.toLocaleLowerCase()}`}>{row.poolStatus}</span>;
      },
      sortable: true,
      id: ColumnsFXPoolDetails.poolStatus,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.poolStatus),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.poolStatus),
      minWidth: "150px",
      center: true
    },
    {
      name: 'Proof Of Purchase',
      selector: row => row.proofOfPurchaseLocation,
      sortable: true,
      id: ColumnsFXPoolDetails.proofOfPurchaseLocation,
      hide: isColumnExcludedFromExport(listColumnsToHide, listColumnsToExcludeFromExport, ColumnsFXPoolDetails.proofOfPurchaseLocation),
      omit: isColumnHidden(listColumnsToHide, ColumnsFXPoolDetails.proofOfPurchaseLocation),
      minWidth: "200px"
    }
  ];
  return columns;
}

export const getRequestDataForReportsWithDateAndPage = (state: ReportsStateCommon, isCsv = false) => {
  let monthRange = getLast30DaysRange();
  const startDate = state.selectedDateRange.startDate === '' ? monthRange.startDate : state.selectedDateRange.startDate;
  const endDate = state.selectedDateRange.endDate === '' ? monthRange.endDate : state.selectedDateRange.endDate;
  const countryId = state.countryId ? state.countryId : null;
  let req: any = {
    pageNumber: state.currentPage,
    recordPerPage: state.currentRowsPerPage,
    startDate,
    endDate
  };

  if (isCsv) {
    delete req.pageNumber;
    delete req.recordPerPage;
  };

  if (countryId) {
    req.countryId = countryId
  }

  if (state.searchText) {
    req.searchText = state.searchText
  }
  console.log('req', req)
  return req;
}

export const clearLocalStorage = () => {
  console.warn("Permission denied, logging out...");
  localStorage.clear();
  window.location.href = '/';
}
export class ReportsCommon {
  public static onSearchReportWithDateFilter(searchText_: string, selectedDateRange: ISelectedDateRangeString | null) {
    console.log(searchText_)
    console.log(this)
    const _this: any = this;
    const newDate = selectedDateRange === null ? { startDate: null, endDate: null } : selectedDateRange;
    _this.setState({
      searchText: searchText_,
      emailId: searchText_,
      currentPage: 1,
      selectedDateRange: newDate,
      appliedFiltersCount: searchText_ ? 0 : selectedDateRange !== null ? 1 : _this.state.appliedFiltersCount,
      countryId: searchText_ ? '' : _this.state.countryId
    }, () => {
      _this.fetchReportData();
    });
  }
  public static onApplyDateFilter(filteredDate: ISelectedDateRangeString) {
    const _this: any = this;
    _this.setState({
      selectedDateRange: filteredDate,
      currentPage: 1
    }, () => {
      _this.fetchReportData();
    })
  }
  public static onReportPageChange(page: number) {
    const _this: any = this;
    _this.setState({ currentPage: page }, () => {
      _this.fetchReportData();
    });
  }
  public static onReportRowPerPageChange(rowsPerPage_: number, currentPage_: number) {
    const _this: any = this;
    _this.setState({ currentRowsPerPage: rowsPerPage_, currentPage: currentPage_ }, () => {
      _this.fetchReportData();
    });
  }
}

export default states;
